import React, { ReactNode } from 'react';
import { Table, TableRenderProps } from './table';
import { TableRow, TableData } from '@make-software/cspr-design';
import Skeleton from 'react-loading-skeleton';

type Props = {
  columnsLength: number;
  rowsLength?: number;
  renderDataHeaders?: (renderProps: TableRenderProps) => ReactNode;
  renderHeader?: (renderProps: TableRenderProps) => ReactNode;
  renderFooter?: (renderProps: TableRenderProps) => ReactNode;
};

/**
 * @deprecated WARNING: DO NOT USE THIS COMPONENT, IT'S DUE REFACTORING
 */
export function TableLoader({
  columnsLength,
  rowsLength = 10,
  renderDataHeaders,
  renderHeader,
  renderFooter,
}: Props) {
  const tableData = Array(rowsLength).fill(undefined);
  const columnsRow = Array(columnsLength).fill(null);

  return (
    <Table
      renderHeader={renderHeader}
      renderDataHeaders={renderDataHeaders}
      renderData={(renderProps) =>
        tableData.map((item, index) => (
          <TableRow key={'row' + index} loading>
            {columnsRow.map((item2, index2) => (
              <TableData key={'column' + index2}>
                <Skeleton />
              </TableData>
            ))}
          </TableRow>
        ))
      }
      renderFooter={renderFooter}
    />
  );
}
